<template>
  <div>
    <img :src="pixelValue" height="0" width="0" border="0" />
  </div>
</template>
<script script="ts">
import { defineComponent, computed } from '@nuxtjs/composition-api';
import useCurrentUser from '@/hooks/useCurrentUser';

export default defineComponent({
  name: 'ConversionPixel',
  props: {
    pixel: {
      type: String,
      required: true,
    },
    trackUser: {
      type: Boolean,
      default: true,
    },
    hasPixel: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { currentUser } = useCurrentUser();
    const userId = computed(() => currentUser?.userId);
    const pixelValue = computed(() => {
      if (props.hasPixel) {
        return `${props.pixel}${userId.value}&pixid=047b84a4-fac9-4150-8f4d-01006d162e76`;
      }
      if (props.trackUser && !props.pixel) {
        return `${props.pixel}${userId.value}`;
      }

      return `${props.pixel}`;
    });

    return { pixelValue };
  },
});
</script>
